import Vue from "vue";
import Toast from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";
import "./style.scss";
const options = {
  // You can set your default options here
  // @see https://github.com/Maronato/vue-toastification/tree/main#installation
  draggable: false,
  containerClassName: "talent-toast",
};

Vue.use(Toast, options);
